import type { AqItem } from './types';

export const AQ_ITEMS: AqItem[] = [
  {
    id: 'campaign-weekend-emergency',
    type: 'campaign',
    title: "Launch 'Weekend Emergency' campaign",
    summary:
      'A new Google Ads campaign targeting Saturday/Sunday emergency searches at $40/day.',
    minutesAgo: 12,
    createdBy: 'Prepared by ELVA',
    priority: 'high',
    reason:
      "Your competitor 'Smile Central' stopped bidding on weekend emergency keywords, dropping CPC by 35%.",
    facts: [
      { label: 'Budget', value: '$40/day - $1,200/mo' },
      { label: 'Expected patients', value: '3-5/week' },
      { label: 'Confidence', value: '88%' },
    ],
    reviewTo: '/google-ads-seo/campaigns/create/preview/1',
  },
  {
    id: 'article-broken-tooth-night',
    type: 'article',
    title: "'What to Do for a Broken Tooth at Night'",
    summary:
      "A 2,400-word SEO article targeting 'broken tooth at night' (3,200 searches/mo).",
    minutesAgo: 60,
    createdBy: 'Prepared by ELVA',
    priority: 'medium',
    reason:
      'Keyword ranking moved from #14 to #6. Publishing a supporting article can improve page-1 stability.',
    facts: [
      { label: 'Target keyword', value: 'broken tooth at night' },
      { label: 'Word count', value: '2,400 words' },
      { label: 'Content status', value: 'Ready for review' },
    ],
    reviewTo: '/google-ads-seo/articles/1',
  },
  {
    id: 'campaign-budget-implants',
    type: 'campaign',
    title: "Increase 'Dental Implants' budget +25%",
    summary: 'A budget change proposal raising daily spend from $80 to $100.',
    minutesAgo: 120,
    createdBy: 'Prepared by ELVA',
    priority: 'high',
    reason:
      'Implant calls increased this week while cost per patient improved by 11%. Additional spend is still within guardrails.',
    facts: [
      { label: 'Current budget', value: '$80/day' },
      { label: 'Proposed budget', value: '$100/day' },
      { label: 'Estimated uplift', value: '+2-3 patients/week' },
    ],
    reviewTo: '/google-ads-seo/campaigns/1',
  },
  {
    id: 'article-invisalign-vs-braces',
    type: 'article',
    title: "'Invisalign vs Braces: Cost Comparison 2026'",
    summary:
      'A 1,800-word comparison guide prepared with local Manhattan pricing references.',
    minutesAgo: 240,
    createdBy: 'Prepared by ELVA',
    priority: 'low',
    reason:
      'Competitor pages for treatment comparison are ranking above your site in mid-funnel searches.',
    facts: [
      { label: 'Target intent', value: 'Mid-funnel comparison' },
      { label: 'Word count', value: '1,800 words' },
      { label: 'Internal links', value: '7 suggested' },
    ],
    reviewTo: '/google-ads-seo/articles/1',
  },
  {
    id: 'landing-page-emergency-weekend',
    type: 'landing-page',
    title: 'Landing page: /emergency-weekend',
    summary:
      'A dedicated landing page connected to the Weekend Emergency campaign.',
    minutesAgo: 12,
    createdBy: 'Prepared by ELVA',
    priority: 'medium',
    reason:
      'Weekend traffic performs better with a focused page that highlights same-day availability and emergency phone CTAs.',
    facts: [
      { label: 'Template', value: 'Emergency LP v2' },
      { label: 'Variants', value: 'A/B ready' },
      { label: 'Goal', value: 'Call + form conversion' },
    ],
    reviewTo: '/google-ads-seo/landing-pages/preview',
  },
  {
    id: 'review-reply-mike',
    type: 'review-reply',
    title: 'Review reply: 2-star service delay feedback',
    summary:
      'ELVA drafted a response and flagged it for approval before posting.',
    minutesAgo: 75,
    createdBy: 'Prepared by ELVA',
    priority: 'medium',
    reason:
      'A fast, professional response helps recover trust and reduces negative review impact in map-pack visibility.',
    facts: [
      { label: 'Platform', value: 'Google Business Profile' },
      { label: 'Review score', value: '2 stars' },
      { label: 'Draft quality', value: 'Ready to publish' },
    ],
    reviewTo: '/google-ads-seo/google-business-profile-manager',
  },
  {
    id: 'gbp-post-whitening',
    type: 'gbp-post',
    title: 'GBP post: April whitening special',
    summary:
      'New promotional GBP post prepared with image + CTA for limited appointment slots.',
    minutesAgo: 180,
    createdBy: 'Prepared by ELVA',
    priority: 'low',
    reason:
      'Weekly posting consistency supports local visibility and can increase map-pack engagement rate.',
    facts: [
      { label: 'Post type', value: 'Offer' },
      { label: 'Media', value: '1 image attached' },
      { label: 'Duration', value: '14 days' },
    ],
    reviewTo: '/google-ads-seo/google-business-profile-manager',
  },
];
